export const getEnteredByStyles = ({ isCompact }) => ({
  display: 'flex',
  alignItems: isCompact ? 'center' : 'flex-start',
  gap: '8px',
});

export const enteredByTextStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};
